/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsControllerFindManyQueryResponse,
  TelegramProductsControllerFindManyQueryParams,
  TelegramProductsControllerFindMany401,
} from '../../types/TelegramProductsControllerFindMany.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsFindMany } from '../../methods/telegramProductsFindMany.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsFindManyQueryKey = (params: TelegramProductsControllerFindManyQueryParams) =>
  [{ url: '/api/telegram/products/many' }, ...(params ? [params] : [])] as const;

export type TelegramProductsFindManyQueryKey = ReturnType<typeof telegramProductsFindManyQueryKey>;

export function telegramProductsFindManyQueryOptions(
  params: TelegramProductsControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsFindManyQueryKey(params);
  return queryOptions<
    TelegramProductsControllerFindManyQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindMany401>,
    TelegramProductsControllerFindManyQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsFindMany(params, config);
    },
  });
}

/**
 * {@link /api/telegram/products/many}
 */
export function useTelegramProductsFindMany<
  TData = TelegramProductsControllerFindManyQueryResponse,
  TQueryData = TelegramProductsControllerFindManyQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsFindManyQueryKey,
>(
  params: TelegramProductsControllerFindManyQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsControllerFindManyQueryResponse,
        ResponseErrorConfig<TelegramProductsControllerFindMany401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsFindManyQueryKey(params);

  const query = useQuery(
    {
      ...telegramProductsFindManyQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsControllerFindMany401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
